import { render, staticRenderFns } from "./Login_normal.vue?vue&type=template&id=495ff97d"
import script from "./Login_normal.vue?vue&type=script&lang=js"
export * from "./Login_normal.vue?vue&type=script&lang=js"
import style0 from "./Login_normal.vue?vue&type=style&index=0&id=495ff97d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports